export const sharedStyles = {
  container: {
    backgroundColor: '#f9fafb',
    minHeight: '100vh',
    padding: '40px 20px',
  },
  inner: {
    maxWidth: '960px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    padding: '40px',
    fontFamily: `'Helvetica Neue', sans-serif`,
  },
  heading: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '30px',
    borderBottom: '4px solid #FFD700',
    display: 'inline-block',
    paddingBottom: '10px',
  },
  label: {
    fontWeight: '600',
    marginBottom: '6px',
    display: 'block',
    fontSize: '16px',
  },
  input: {
    width: '96.5%',
    marginBottom: '16px',
    padding: '16px',
    borderRadius: '12px',
    border: '1px solid #ccc',
    backgroundColor: '#fdfdfd',
    fontSize: '16px',
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.06)',
  },
  select: {
    width: '100%',
    marginBottom: '16px',
    padding: '16px',
    borderRadius: '12px',
    border: '1px solid #ccc',
    backgroundColor: '#fdfdfd',
    fontSize: '16px',
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.06)',
  },
  checkboxGroup: {
    marginBottom: '24px',
  },
  checkboxLabel: {
    fontSize: '16px',
    display: 'block',
    marginBottom: '10px',
  },
  toggleRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    gap: '10px',
  },
  button: {
    marginTop: '16px',
    backgroundColor: '#FFD700',
    color: '#000',
    fontSize: '16px',
    fontWeight: '600',
    padding: '12px 24px',
    borderRadius: '12px',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  },
  sectionHeader: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#DAA520',
    borderBottom: '2px solid #DAA520',
    paddingBottom: '4px',
    marginTop: '30px',
    marginBottom: '10px',
  },
  resultBox: {
    marginTop: '40px',
    backgroundColor: '#ffffff',
    padding: '30px',
    borderRadius: '16px',
    border: '1px solid #ccc',
    fontSize: '15px',
  },
  chatContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '40px',
  },
  chatBubble: {
    padding: '12px 16px',
    borderRadius: '14px',
    maxWidth: '96.5%',
    whiteSpace: 'pre-wrap',
    lineHeight: '1.5',
    fontSize: '15px',
  },
  userBubble: {
    backgroundColor: '#e0f0ff',
    alignSelf: 'flex-end',
  },
  alfredBubble: {
    backgroundColor: '#f0f0f0',
    alignSelf: 'flex-start',
  },
  formGridTwoCol: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
  },
  readonlyInput: {
    backgroundColor: '#eee',
    color: '#555',
    cursor: 'not-allowed',
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px',
  },
  disabledInput: {
    backgroundColor: '#f3f4f6',
    color: '#6b7280',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
  threadContainer: {
    backgroundColor: '#f9fafb',
    minHeight: '100vh',
    padding: '40px 20px',
  }
};
